import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId500066: SiteIdOverrideConfig = {
  car: {
    disableVendorCouponCode: true,
  },
};
